export const pendingTransactionsHaveFinished = (
  newPendingState: boolean,
  pendingStateFromMostRecentRender: boolean
): boolean => newPendingState !== pendingStateFromMostRecentRender && newPendingState === false
